import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SectionList, View } from 'react-native';
import styles from './scrollable-layout.styles';
import add from 'lodash/fp/add';
import every from 'lodash/fp/every';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import gte from 'lodash/fp/gte';
import identity from 'lodash/fp/identity';
import keys from 'lodash/fp/keys';
import lte from 'lodash/fp/lte';
import map from 'lodash/fp/map';
import min from 'lodash/fp/min';
import overEvery from 'lodash/fp/overEvery';
import property from 'lodash/fp/property';
import toInteger from 'lodash/fp/toInteger';

const HEADER_COMPONENT_HEIGHT = 85;

// Detect whether an argument has the shape: [{ rows: [...] }, ...]
const bodyHasSections = overEvery([Array.isArray, every(flow(get('rows'), Array.isArray))]);

// Build a section with no header and one row
const sectionOf = x => [{ rows: [x] }];

//Build sticky section with no row
const sectionOfHeader = (x)=>[{rows:[], header : x}];

class ScrollableLayout extends PureComponent {
  constructor() {
    super();
    this.state = { stickyId: -1 };
    this.renderSectionHeader = this.renderSectionHeader.bind(this);
    this.onChangeVisibleRows = this.onChangeVisibleRows.bind(this);
  }

  onChangeVisibleRows(visibleRows) {
    this.setState({ stickyId: flow(keys, map(toInteger), min)(visibleRows) });
  }

  onViewableItemsChanged = ({viewableItems, changed}) => {
    this.setState({ stickyId: flow(keys, map(toInteger), min)(viewableItems) });
  };


  mainStickyHeaderIsSticking() {
    return this.state.stickyId > 0;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.scrollOffset != null && this.props.scrollOffset !== newProps.scrollOffset) {
      this.shouldScroll = true;
    }
  }

  componentDidUpdate() {
    if (this.shouldScroll) {
      const internalOffset = HEADER_COMPONENT_HEIGHT + this.props.scrollOffset;
      this.handleScrollTo(internalOffset);
      this.shouldScroll = false;
    }
  }

  handleScrollTo(y) {
    this.listView.scrollTo({ y });
  }

  renderSectionHeader({section}) {
    return (
      <div testID="scrollable-layout-header-container">
        {section.header}
      </div>
    );
 }

  render() {
    const { testID, header, body , stickyHeader} = this.props;
    const bodySections = bodyHasSections(body) ? body : sectionOf(body);
   // const sections = (header ? sectionOf(header) : []).concat(bodySections);
    const sections = (stickyHeader ? sectionOfHeader(stickyHeader) : []).concat(bodySections);

    const sectionWithData = sections.map((section, index)=>{
      return {
        header: section.header || null,
        data: section.rows,
        index: index
       }
    });

    return (      
   
      <div className="row"
       testID={testID}
      >
        <div  className={`columns small-12 ${this.props.testID && this.props.testID.includes('maturities-assets') ?'zoom-for-maturities' :''} ${this.props.testID==='reports-screen' ?'zoom-for-reports' :''}` }>
          <SectionList
            scrollEnabled={this.props.scrollable}
            ref={ref => { this.listView = ref; }}
            sections={sectionWithData}
            renderItem={({item})=>{
              return item;
            }}
            ListHeaderComponent={header || null}
            renderSectionHeader={this.renderSectionHeader}
            onChangeVisibleRows={this.onChangeVisibleRows}
            className={'list-view'}
            keyExtractor={(item, index) => index}
            stickySectionHeadersEnabled={true}
            stickyHeaderIndices ={[0]}
            onViewableItemsChanged={this.onViewableItemsChanged}
          />
        </div>
      </div>
    );
  }
}

ScrollableLayout.defaultProps = {
  scrollable: true,
};

const bodyComponentType = PropTypes.node;

const bodySectionsType = PropTypes.arrayOf(PropTypes.shape({
  header: PropTypes.node,
  rows: PropTypes.arrayOf(PropTypes.node).isRequired,
}));

ScrollableLayout.propTypes = {
  testID: PropTypes.string,
  header: PropTypes.node,
  stickyHeader: PropTypes.node,
  body: PropTypes.oneOfType([bodySectionsType, bodyComponentType]),
  scrollOffset: PropTypes.number,
  scrollable: PropTypes.bool,
};

export default ScrollableLayout;